// src/components/ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// rotas que devem sempre começar no topo
const RESET_ROUTES = ["/login", "/cadastro", "/HomePage", "/cadastro-dados-e-senha-musa"];

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const navType = useNavigationType();   // PUSH, POP, REPLACE

  useEffect(() => {
    // Evita “subir” quando o usuário só deu back/forward (POP),
    // mas sobe em navegações novas (PUSH/REPLACE) — e somente nas rotas listadas
    if (
      navType !== "POP" &&
      RESET_ROUTES.some((base) => pathname.startsWith(base))
    ) {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
  }, [pathname, navType]);

  return null;
}